import React, { useEffect } from "react";
import Banner from "../components/accounts/Banner";
import Tiers from "../components/accounts/Tiers";
import Levels from "../components/accounts/Levels";
import Growth from "../components/accounts/Growth";
import FAQ from "../components/accounts/FAQ";
import CTA from "../components/accounts/CTA";

function Accounts() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="overflow-hidden pb-[80px] xl:pb-0">
      <Banner />
      <Tiers />
      <Levels />
      <Growth />
      <FAQ />
      <CTA />
    </div>
  );
}

export default Accounts;
